import { render, staticRenderFns } from "./ColorRel.vue?vue&type=template&id=773d7c00&scoped=true"
import script from "./ColorRel.vue?vue&type=script&lang=ts"
export * from "./ColorRel.vue?vue&type=script&lang=ts"
import style0 from "./ColorRel.vue?vue&type=style&index=0&id=773d7c00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773d7c00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VSheet})
